// extracted by mini-css-extract-plugin
export var dropdown = "_s2-0";
export var imageWrapper = "_s2-3";
export var itemNameContainer = "_s2-1";
export var productImage = "_s2-2";
export var spinnerWrapper = "_s2-4";